/**
 * Retrieve the value of a specific node in the topic path
 *
 * Example
 *
 * var x = getTopicNode('foo/bar/yeah' , 1) >>> output: 'bar'
 *
 * @param {String} topic
 * @param {Integer} idx
 * @param {Boolean} fromLast
 */
export function getTopicNode(topic, idx, fromLast = false) {
  const topicNodes = topic.split("/");
  const topicDepth = topicNodes.length;

  if (topicDepth > 0) {
    return topicNodes[fromLast ? topicDepth - 1 - idx : idx];
  } else {
    return "";
  }
}
